import type { GeometryInputs, GeometryMode, GeometryResult } from "./types";

function toInchFraction(value: number, denominator = 64) {
  const whole = Math.trunc(value);
  const fraction = Math.round((value - whole) * denominator);

  if (fraction === 0) return `${whole}"`;
  if (fraction === denominator) return `${whole + 1}"`;

  const divisor = gcd(fraction, denominator);
  return `${whole} ${fraction / divisor}/${denominator / divisor}"`;
}

function gcd(a: number, b: number): number {
  return b === 0 ? a : gcd(b, a % b);
}

export function calculateGeometry(mode: GeometryMode, inputs: GeometryInputs): GeometryResult {
  const halfAngleRadians = (inputs.angle / 2) * (Math.PI / 180);
  const legFactor = 1 / Math.cos(halfAngleRadians);
  const aMass = mode === "aMass" ? inputs.zMeasure / legFactor : inputs.aMass;
  const zMeasure = mode === "zMeasure" ? inputs.aMass * legFactor : inputs.zMeasure;
  const zMeasureInch = zMeasure / 25.4;

  return {
    mode,
    value: mode === "zMeasure" ? zMeasure : aMass,
    aMass,
    zMeasure,
    zMeasureInch,
    zMeasureFraction: toInchFraction(zMeasureInch),
    legFactor
  };
}
